<footer class="site-footer">
  <div>
    <div class="d-flex justify-content-center container">
      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h4 class="footer-title">Capabilities</h4>
        <ul class="footer-menu">
          <li><a routerLink="/endpoint" [queryParams]="{ page: 1, size: 15 }">Functional Automation</a></li>
          <li><a routerLink="/mobileAutomation/overview">Mobile Automation</a></li>
          <li><a routerLink="/desktopAutomation/overview">Desktop Automation</a></li>
          <li><a routerLink="/performance">Performance Lab</a></li>
          <li><a routerLink="/chaos/overview">Chaos Simulator</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h4 class="footer-title">Repository</h4>
        <ul class="footer-menu">
          <li><a routerLink="/endpoint" [queryParams]="{page: 1, size: 15}" id="nav-endpoint">Endpoint</a></li>
          <li><a routerLink="/testcase" [queryParams]="{page: 1, size: 15}" id="nav-testcase">Testcase</a></li>
          <li><a routerLink="/testsuite" [queryParams]="{page: 1, size: 15}" id="nav-testsuite">Testsuite</a></li>
          <li><a routerLink="/mastersuite" [queryParams]="{page: 1, size: 15}" id="nav-mastersuite">Mastersuite</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h4 class="footer-title">Result</h4>
        <ul class="footer-menu">
          <li><a routerLink="/history/testcase" id="nav-history-testcase" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_CASE' }" [class.active]="isRouteActive(['/history/testcase', '/results/testcase'])">Test Case</a></li>
          <li><a routerLink="/history/testsuite" id="nav-history-testsuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'TEST_SUITE' }" [class.active]="isRouteActive(['/history/testsuite', '/results/testsuite'])">Test Suite</a></li>
          <li><a routerLink="/history/mastersuite" id="nav-history-mastersuite" [queryParams]="{ page: 1, size: 15, executedBy: this.userData?.id, executionType: 'MASTER_SUITE' }" [class.active]="isRouteActive(['/history/mastersuite', '/results/mastersuite'])">Master Suite</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h4 class="footer-title">Contact Us</h4>
        <ul class="footer-menu">
          <li><a href="mailto:Grp-Relay-Team@adobe.com"><i class="far fa-envelope"></i>{{'Grp-Relay-Team@adobe.com'}}</a></li>
          <li><a href="https://adobe-relay.slack.com/" target="_blank"><i class="fab fa-slack"></i> Adobe-Relay</a></li>
          <li><a href="https://wiki.corp.adobe.com/display/Relay/Relay" target="_blank"><i class="fas fa-link"></i> Relay</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12 text-center">
          <p class="copyright-text">© {{ currentYear }} Relay AI. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</footer>